export default __webpack_public_path__ + "static/media/Logo-Ct-mini.54b33cae.svg";